import { cloneDeep as e } from "../../../../utils/cloneDeep.js";
import { getStrategy as t } from "../core/libs/strategy/strategy-provider.js";
import { selectCtx as n, selectEvents as r } from "../core/models/selectors/index.js";
import { useDatePickerStore as i } from "../core/models/use-date-picker-store.js";
import { Pipeline as a } from "../utilities/pipeline.js";
import { today as o } from "../core/config/index.js";
import { useMemo as s } from "react";
import { jsx as c } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/today-button.tsx
var l = (n) => {
	let r = e(n), i = t(r.isNepali), { next: s } = a().push(i.setIsTodayValid(o)).execute({ next: r });
	return s.isTodayValid;
}, u = ({ onClick: e, children: t }) => {
	let a = i(n), o = s(() => l(a), [a]), { selectToday: u } = i(r);
	return /* @__PURE__ */ c("button", {
		disabled: !o,
		onClick: (t) => {
			o && (u(), e?.(t));
		},
		children: t ?? "Today"
	});
};
export { u as TodayButton };

//# sourceMappingURL=today-button.js.map